import './style.scss'

import { createApp, type App } from 'vue'

import { getAdminEmail } from './elements/admin'

import Client from './Client.vue'

let app: App

const events = [ 'updated_checkout', 'cart_page_refreshed' ]

function init() {
	const appElement = document.getElementById( 'innosend' )
	if ( ! appElement ) return

	if ( app ) {
		app.unmount()
	}

	app = createApp( Client )

	app.mount( '#innosend' )
}

document.addEventListener( 'DOMContentLoaded', () => {
	init()
	events.forEach( ( event ) => jQuery( document.body ).on( event, init ) )
} )

getAdminEmail()
